import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconKey: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        d="M11.75 2C6.39474 2 2 6.39474 2 11.75C2 17.1053 6.39474 21.5 11.75 21.5C17.1053 21.5 21.5 17.1053 21.5 11.75C21.5 6.39474 17.1053 2 11.75 2Z"
        fill={fill}
      />
      <path
        d="M14.6313 14.4451V12.2227"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4453 12.2227H18.0269V14.4451"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4436 12.2224C10.4436 13.4488 9.4488 14.4448 8.2212 14.4448C6.9948 14.4448 6 13.4488 6 12.2224C6 10.996 6.9948 10 8.2212 10C9.4488 10 10.4436 10.996 10.4436 12.2224Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default IconKey;
